import React from 'react';

interface Props {
  title: string;
  body: string;
  targetCount?: number;
}

/** 기기에서 보이는 모습과 예상 발송 대상 수 */
function Preview({ title, body, targetCount }: Props) {
  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: '12px 0' }}>
      <div
        css={{
          background: '#f2f3f5',
          borderRadius: '12px',
          padding: '16px',
        }}
      >
        <p css={{ fontSize: '12px', color: '#8a8d94', marginBottom: '8px' }}>
          연봉인상 · 지금
        </p>
        <p css={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px' }}>
          {title || '제목을 입력해주세요'}
        </p>
        <p css={{ fontSize: '13px', color: '#4b4d53' }}>
          {body || '내용을 입력해주세요'}
        </p>
      </div>

      <div css={{ fontSize: '13px', color: '#5f6069' }}>
        예상 발송 대상{' '}
        <strong>
          {targetCount === undefined ? '-' : targetCount.toLocaleString()}
        </strong>
        명
        <p css={{ fontSize: '12px', color: '#90929a', marginTop: '4px' }}>
          해당 유형의 푸시 수신에 동의하고 기기가 등록된 회원 수입니다. 실제
          발송 시점에 다시 산정됩니다.
        </p>
      </div>
    </div>
  );
}

export default Preview;
